export const PDF_MIMETYPE = 'application/pdf';

// Keep in sync with GENERAL_FILE_MIMETYPES in
// idealist/utils/listingapplications.py
export const GENERAL_FILE_MIMETYPES = [
  PDF_MIMETYPE,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'image/jpeg',
  'image/png',
  'text/plain',
];

export function isPdfOnly(mimetypes: string[] | null | undefined): boolean {
  return mimetypes?.length === 1 && mimetypes[0] === PDF_MIMETYPE;
}
